import { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  stickyReminder: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    
    zIndex: 1300, // higher than AppBar
    backgroundColor: "#f8f8f8",
    borderBottom: "1px solid #ffeeba",
  },

  stickyContent: {
    maxWidth: theme.spacing(175), // ~1400px
    marginLeft: "auto",
    marginRight: "auto",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontSize: 10,
    fontWeight: 500,
  },

  stickyText: {
    color: "#856404",
    display: "flex",
    alignItems: "center",
    fontSize:18
  },
   stickyText2: {
    color: "#856404",
    display: "flex",
    alignItems: "center",
    fontSize:36
  },

  stickyButton: {
    marginLeft: theme.spacing(2),
    backgroundColor: "#856404",
    color: "#ffffff",
    border: "none",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    cursor: "pointer",
    borderRadius: 4,
    fontSize: 12,
    "&:hover": {
      backgroundColor: "#6c5203",
    },
  },
}));

const StickyReminderBanner = ({ bannerarray }) => {
  console.log(bannerarray)
  const classes = useStyles();
//   useEffect(() => {
//     if (!isTaskCompleted) {
//       setVisible(true);
//     } else {
//       setVisible(false);
//     }
//   }, [isTaskCompleted]);

//   if (!visible) return null;

  return (
    <div className={classes.stickyReminder}>
    {bannerarray.map(b=>{return(
        <div>
        {b && !b.isTaskCompleted?(
        <div className={classes.stickyContent}>
        <span className={b.role=="Admin"?classes.stickyText:classes.stickyText2}>⚠️ {b.header+"  "}{b.message}</span>
       
      </div>
      ):("")}
      </div>
    )})}
      
    </div>
  );
};

export default StickyReminderBanner;